import React from 'react';
import {Trash} from '../../assets/icons/icons';
import {TableBasic} from './styles';

export default () => (
  <TableBasic>
    <thead>
      <tr>
        <th className="header-centered">PLAYER</th>
        <th className="header-centered">DATES</th>
        <th className="header-centered">EVENT</th>
        <th className="header-centered">SITUATION</th>
        <th className="header-centered">BALL TYPE</th>
        <th className="header-centered">PITCH TYPE</th>
        <th className="header-centered">MAX. VELO</th>
        <th className="header-centered">TREND</th>
        <th className="header-centered">AVG VELO</th>
        <th className="header-centered">TREND</th>
        <th className="header-centered">NOTE</th>
        <th className="header-centered">DELETE</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Thenjiwe Msutu</td>
        <td>jun 15 2019</td>
        <td>Game</td>
        <td>Mound</td>
        <td>Standard</td>
        <td>Fastball</td>
        <td>1599</td>
        <td>20%</td>
        <td>1599</td>
        <td>20%</td>
        <td>Felt good lorem impsu, new text test</td>
        <td className="white">
          <div className="td-center-y pointer">
            <Trash />
          </div>
        </td>
      </tr>
    </tbody>
  </TableBasic>
);
